import { render, staticRenderFns } from "./stake.vue?vue&type=template&id=44de8ea2&"
import script from "./script/stake.js?vue&type=script&lang=js&"
export * from "./script/stake.js?vue&type=script&lang=js&"
import style0 from "./stake.vue?vue&type=style&index=0&id=44de8ea2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports